// extracted by mini-css-extract-plugin
export default {"input":"Input_input__4BtJl","small":"Input_small__xpfg2","normal":"Input_normal__q5NyH"};